import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { PATH } from '../app.api'
import { Address } from '../models/Address'
import { PlantingDetailsSchedule, PlantingOpportunity, PlantingOpportunityReportArboreal, PlantingOpportunityScheduler, PlantingReportArboreal, PlantingScheduler } from '../models/Planting'
import { NotificationService } from './notification.service'
import * as FileSaver from 'file-saver'

@Injectable()
export class PlantingService {
		constructor(
		private notificationService: NotificationService,
		private http: HttpClient
	) {}

	public exportSchedulePlantingOpportunityXmls(companyId: string, dateStart?: number, dateEnd?: number) {
		const options: any = this.setHeader()

		return this.http.get<any>(`${PATH}/planting/schedule/all?companyId=${companyId}&dateStart=${dateStart}&dateEnd=${dateEnd}`, {
			headers: options
		}).pipe(
			map(result => {
				const stringBase64 = result.content

				if (stringBase64 == undefined) {
					return this.notificationService.notify('Não há dados a serem exportados', 420)
				}
				// Decodificar a string Base64 para um array de bytes
				const byteCharacters = atob(stringBase64)
				const byteNumbers = new Array(byteCharacters.length)

				for (let i = 0; i < byteCharacters.length; i++) {
				  byteNumbers[i] = byteCharacters.charCodeAt(i)
				}

				const byteArray = new Uint8Array(byteNumbers)

				const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

				// Realizar o download do arquivo automaticamente
				FileSaver.saveAs(blob, `Relatório_de_agendamento_de_plantio_export_${new Date().getTime()}.xlsx`)
			})
		)
	}

	public exportPlantingOpportunityXmls(companyId: string, dateStart?: number, dateEnd?: number) {
		const options: any = this.setHeader()

		return this.http.get<any>(`${PATH}/planting/history/all?companyId=${companyId}&dateStart=${dateStart}&dateEnd=${dateEnd}`, {
			headers: options
		}).pipe(
			map(result => {
				const stringBase64 = result.content

				if (stringBase64 == undefined) {
					return this.notificationService.notify('Não há dados a serem exportados', 420)
				}
				// Decodificar a string Base64 para um array de bytes
				const byteCharacters = atob(stringBase64)
				const byteNumbers = new Array(byteCharacters.length)

				for (let i = 0; i < byteCharacters.length; i++) {
				  byteNumbers[i] = byteCharacters.charCodeAt(i)
				}

				const byteArray = new Uint8Array(byteNumbers)

				const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

				// Realizar o download do arquivo automaticamente
				FileSaver.saveAs(blob, `Relatório_de_histórico_de_plantio_export_${new Date().getTime()}.xlsx`)
			})
		)
	}

	public listOperatorForSchedulingDate({companyId, date, lat, lng}): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.patch<any>(
				`${PATH}/operationService/scheduling/operators`,
				{companyId, date, lat, lng},
				{ headers: options }
			)
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getCoordinatesPlantingScheduler(companyId): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(
				`${PATH}/planting/coordinates-planting-scheduler/${companyId}`,
				{ headers: options }
			)
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public operationScheduler(data: Array<PlantingOpportunityScheduler>) {
		const options: any = this.setHeader()
		return this.http.patch(`${PATH}/planting/scheduling/assign`, {
			plantings: data
		}, {
			headers: options
		})
	}

	public getSpecies(valueSearch: string): Observable<any> {
		const options: any = this.setHeader()

		try {
			return this.http.post(`${PATH}/app/species/filter`, {key: valueSearch}, options).pipe(
				map(result => {
					return result
				})
		  	)
		} catch (err) {
			console.log(err)
		}
	}

		public getPlantingSchedule(
		companyId: string,
		skip: any,
		limit: any,
		order: any,
		typeOrder: any,
		filterText: any,
		status: any): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/planting/scheduler?companyId=${companyId}&skip=${skip}&limit=${limit}&order=${order}&typeOrder=${typeOrder}&search=${filterText}&dateStart=&dateEnd=&status=${status}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getPlantingDetails(idMongo: string): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.get<any>(`${PATH}/planting/planting-details/${idMongo}`, {
				headers: options
			}).pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getPlantingScheduling(idsMongo: Array<string>): Observable<Array<PlantingOpportunityScheduler>> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.get<any>(`${PATH}/planting/planting-scheduling/${idsMongo}`, {
				headers: options
			}).pipe(
				map(result => {
					return result.content
				})
			)
	}

		public removeToPageSchedule(plantingId: string): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.delete<any>(`${PATH}/planting/removeToSchedule/${plantingId}`,
			{ headers: options }
		)
	}

	public cancelSchedule(
		operationId: string,
		justifyCancel: string
	): Observable<any> {
		return this.http.patch<any>(
			`${PATH}/operationService/scheduling/${operationId}`,
			{justification: justifyCancel},
			{ headers: this.setHeader() }
		)
	}

	public getPlantingHistoryMap(companyId: string): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/planting/history/map/${companyId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getPlantingScheduleMap(companyId: string): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/planting/schedule/map/${companyId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getQuestionStatePlantingOpportunity(companyId: string): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/planting/questions/${companyId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public inactivePlaanting(plantingId: string): Observable<PlantingOpportunity> {
		const options: any = this.setHeader()

		return this.http
			.delete<any>(`${PATH}/planting/remove/${plantingId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result
				})
			)
	}

	public reactivatePlanting(plantingId: string): Observable<PlantingOpportunity> {
		const options: any = this.setHeader()

		return this.http
			.patch<any>(`${PATH}/planting/reactivatePlanting/${plantingId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result
				})
			)
	}

	public getClickPlanting(plantingId: string, companyId: string): Observable<any> {
		const options = this.setHeader()

		return this.http
			.get<any>(`${PATH}/planting/getClick/${plantingId}/${companyId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getClickPlantingOpportunity(plantingId: string, companyId: string): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/planting/schedule/getClick/${plantingId}/${companyId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public updateLocationPinMapHistory(locationData: { idMongo: string, lat: number, lng: number }): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.patch<any>(`${PATH}/planting/maps/updatePin`, JSON.stringify(locationData), {
				headers: options
			})
			.pipe(
				map(result => {
					return result
				})
			)
	}

	public updateLocationPinMapSchedule(plantingOpportunityId: string, location: Address): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.patch<any>(`${PATH}/planting/maps/schedule/updatePin/${plantingOpportunityId}`, JSON.stringify(location), {
				headers: options
			})
			.pipe(
				map(result => {
					return result
				})
			)
	}

	public updateMapCache(companyId: string, userEmail: string): Observable<Array<any>> {
		const options: any = this.setHeader()

		return this.http
			.patch<any>(`${PATH}/planting/history/${companyId}/${userEmail}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public updateMapCacheSchedule(companyId: string, userEmail: string): Observable<Array<any>> {
		const options: any = this.setHeader()

		return this.http
			.patch<any>(`${PATH}/planting/schedule/${companyId}/${userEmail}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public updatePlantingOpportunity(body: PlantingDetailsSchedule): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.patch<any>(`${PATH}/planting/updatePlantingOpportunity`, body, {
				headers: options
			})
			.pipe(
				map(result => {
					return result
				})
			)
	}

	public getPlantingOpportunityReportArboreal(
		plantingsOpportunityIds: string
	): Observable<Array<PlantingOpportunityReportArboreal>> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/planting/plantingOpportunityReportArboreal/${plantingsOpportunityIds}`,
			{
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getPlantingReportArboreal(
		plantingIds: string,
		fragmentId?: string
	): Observable<Array<PlantingReportArboreal>> {
		const options: any = this.setHeader()

		let params = new HttpParams()

		params = params.append('ids', plantingIds)

		if (fragmentId) {
			params = params.append('fragmentId', fragmentId)
		}

		return this.http
			.get<any>(`${PATH}/planting/plantingReportArboreal`,
			{
				params,
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public updatePlantingReportArboreal(planting: PlantingReportArboreal, plantingId: string): Observable<string> {
		const options: any = this.setHeader()

		return this.http.patch<any>(`${PATH}/planting/plantingReportArboreal/${plantingId}`, planting, {
			headers: options
		}).pipe(
			map(result => {
				return result.message
			})
		)
	}

		private setHeader(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' }).append( 'x-source-from', 'PAINEL')
	}
}
